import { SPAIN_ALL, SPAIN_REGIONS, REST_OF_WORLD } from "../lib/taxonomy";
import { Label } from "./ui/label";
import { t } from "../lib/i18n";

/**
 * Multi-select de geografías: España (toda) actúa como atajo que marca/desmarca
 * todas las CCAA + Ceuta + Melilla. "Resto del mundo" es independiente.
 * `value` es siempre una lista de CCAA exactas + opcionalmente REST_OF_WORLD.
 */
export default function GeographySelect({ label = "Geografías objetivo", value = [], onChange, testPrefix = "geo" }) {
  const set = new Set(value);
  const spainAll = SPAIN_REGIONS.every((r) => set.has(r));

  const toggleSpainAll = () => {
    if (spainAll) {
      onChange(value.filter((v) => !SPAIN_REGIONS.includes(v)));
    } else {
      const next = new Set(value);
      SPAIN_REGIONS.forEach((r) => next.add(r));
      onChange(Array.from(next));
    }
  };

  const toggleRegion = (r) => {
    if (set.has(r)) {
      onChange(value.filter((v) => v !== r));
    } else {
      onChange([...value, r]);
    }
  };

  const toggleRoW = () => {
    if (set.has(REST_OF_WORLD)) {
      onChange(value.filter((v) => v !== REST_OF_WORLD));
    } else {
      onChange([...value, REST_OF_WORLD]);
    }
  };

  return (
    <div className="space-y-3" data-testid={`${testPrefix}-section`}>
      {label && <Label className="font-mono-label text-muted-foreground">{label}</Label>}

      <button
        type="button"
        onClick={toggleSpainAll}
        data-testid={`${testPrefix}-spain-all`}
        className={`hairline px-4 py-2 font-mono-label transition-colors w-full text-left ${
          spainAll ? "bg-[#1E3A5F] text-bone border-[#1E3A5F]" : "bg-card hover:bg-bone"
        }`}
      >
        {spainAll ? "✓ " : ""}{SPAIN_ALL}
      </button>

      <div className="flex flex-wrap gap-2">
        {SPAIN_REGIONS.map((r) => {
          const active = set.has(r);
          return (
            <button
              key={r}
              type="button"
              onClick={() => toggleRegion(r)}
              data-testid={`${testPrefix}-region-${r}`}
              className={`hairline px-3 py-1.5 text-sm transition-colors ${
                active ? "bg-[#1E3A5F] text-bone border-[#1E3A5F]" : "bg-card hover:bg-bone"
              }`}
            >
              {r}
            </button>
          );
        })}
      </div>

      <button
        type="button"
        onClick={toggleRoW}
        data-testid={`${testPrefix}-rest-of-world`}
        className={`hairline px-3 py-1.5 text-sm transition-colors ${
          set.has(REST_OF_WORLD) ? "bg-[#1E3A5F] text-bone border-[#1E3A5F]" : "bg-card hover:bg-bone"
        }`}
      >
        {REST_OF_WORLD}
      </button>
    </div>
  );
}
